import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { isPreBuiltLimitedCartOpenedByCustomerSelector } from 'swag-client-common/redux/cart/cart.selectors';
import { WEEK_DAYS } from 'swag-common/constants/days.constant';
var Socials = /*#__PURE__*/function (Socials) {
  Socials["INSTAGRAM"] = "instagram";
  Socials["TIKTOK"] = "tiktok";
  Socials["TWITTER"] = "twitter";
  Socials["FACEBOOK"] = "facebook";
  Socials["LINKEDIN"] = "linkedIn";
  return Socials;
}(Socials || {});
const availableSocials = ['instagram', 'tiktok', 'twitter', 'facebook', 'linkedIn'];
const getSocials = socials => {
  return (socials || []).reduce((acc, social) => {
    if (social.link && social.name && /^(https|http):.+/.test(social.link) && availableSocials.includes(social.name)) {
      acc.push({
        name: social.name,
        url: social.link
      });
      return acc;
    }
    if (social.name === Socials.TIKTOK) {
      acc.push({
        name: social.name,
        url: `https://www.tiktok.com/${social.link}`
      });
    }
    if (social.name === Socials.INSTAGRAM) {
      acc.push({
        name: social.name,
        url: `https://www.instagram.com/${social.link}`
      });
    }
    if (social.name === Socials.TWITTER) {
      acc.push({
        name: social.name,
        url: `https://twitter.com/${social.link}`
      });
    }
    if (social.name === Socials.FACEBOOK) {
      acc.push({
        name: social.name,
        url: `https://www.facebook.com/${social.link}`
      });
    }
    if (social.name === Socials.LINKEDIN) {
      acc.push({
        name: social.name,
        url: `https://www.linkedin.com/${social.link}`
      });
    }
    return acc;
  }, []);
};
const getScheduler = hoursOperations => {
  if (!(hoursOperations !== null && hoursOperations !== void 0 && hoursOperations.some(({
    from,
    to
  }) => typeof from === 'number' && typeof to === 'number'))) {
    return null;
  }
  return transformSchedule(hoursOperations);
};
export const footerDataSelector = state => {
  const {
    swag: {
      storeSettings
    }
  } = window;
  const isCustomerOpenPreBuiltLimitedCart = isPreBuiltLimitedCartOpenedByCustomerSelector(state);
  const logoLinkUrl = isCustomerOpenPreBuiltLimitedCart ? APP_ROUTES.CART : (storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.logoLinkUrl) || APP_ROUTES.HOME;
  return {
    secondaryColor: storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.secondaryColor,
    primaryColor: storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.primaryColor,
    email: storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.companyEmail,
    companyName: storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.companyName,
    scheduler: getScheduler(storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.hoursOperations),
    phone: storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.companyPhone,
    socials: getSocials(storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.socials),
    logo: storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.logoUrl,
    logoLinkUrl,
    timezone: storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.timezone,
    showPhone: storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.companyShowPhone,
    showEmail: storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.companyShowEmail
  };
};
function transformSchedule(hoursOperations) {
  return WEEK_DAYS.map(day => {
    const daySchedule = hoursOperations === null || hoursOperations === void 0 ? void 0 : hoursOperations.find(schedule => schedule.day === day);
    return {
      day,
      from: (daySchedule === null || daySchedule === void 0 ? void 0 : daySchedule.from) !== undefined ? transformTime(daySchedule.from) : null,
      to: (daySchedule === null || daySchedule === void 0 ? void 0 : daySchedule.to) !== undefined ? transformTime(daySchedule.to) : null
    };
  });
}
function transformTime(time) {
  const amOrPm = time >= 12 ? 'pm' : 'am';
  const hours = time % 12 || 12;
  return `${hours}:00${amOrPm}`;
}